import { render, staticRenderFns } from "./NoAprueba.vue?vue&type=template&id=15fee0d9&scoped=true"
import script from "./NoAprueba.vue?vue&type=script&lang=js"
export * from "./NoAprueba.vue?vue&type=script&lang=js"
import style0 from "../apply-step.css?vue&type=style&index=0&id=15fee0d9&prod&scoped=true&lang=css&external"
import style1 from "./NoAprueba.vue?vue&type=style&index=1&id=15fee0d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fee0d9",
  null
  
)

export default component.exports